import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILED,
  EDIT_NOTIFICATIONS,
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_FAILED,
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, remove, update, get, ref, off } from "firebase/database";
import store from '../store/store';
import { callSecureFunction } from '../other/secureFunctions';

export const fetchUserNotifications = () => (dispatch) => {

  const {
    auth,
    userNotificationsRef
  } = firebase;

  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });

  const uid = auth.currentUser.uid;

  off(userNotificationsRef(uid));
  onValue(userNotificationsRef(uid), snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: arr.reverse()
      });
    } else {
      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: []
      });
    }
  });
};

export const fetchNotifications = () => (dispatch) => {

  const {
    notifyRef
  } = firebase;

  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });
  onValue(notifyRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();

      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });

      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_NOTIFICATIONS_FAILED,
        payload: "No data available."
      });
    }
  });
};

export const editNotifications = (notification, method) => (dispatch) => {
  const {
    notifyRef,
    notifyEditRef
  } = firebase;
  dispatch({
    type: EDIT_NOTIFICATIONS,
    payload: { method, notification }
  });
  if (method === 'Add') {
    push(notifyRef, notification);
  } else if (method === 'Delete') {
    remove(notifyEditRef(notification.id));
  } else {
    set(notifyEditRef(notification.id), notification);
  }
}

export const sendNotification = (notification) => async (dispatch) => {
  dispatch({
    type: SEND_NOTIFICATION,
    payload: notification
  });

  try {
    await callSecureFunction('send_notification', { notification });
    dispatch({ type: SEND_NOTIFICATION_SUCCESS, payload: notification });
  } catch (error) {
    dispatch({ type: SEND_NOTIFICATION_FAILED, payload: error.message || 'send_failed' });
  }
};

export const markNotificationRead = (notificationId) => () => {
  const { auth, database } = firebase;
  const uid = auth.currentUser && auth.currentUser.uid;
  if (!uid || !notificationId) return;
  try {
    // El try/catch solo atrapa errores síncronos: sin .catch, un rechazo de
    // update() (p. ej. PERMISSION_DENIED) mostraba "Operación no completada".
    const p = update(ref(database, `userNotifications/${uid}/${notificationId}`), { read: true });
    if (p && typeof p.catch === 'function') p.catch(() => { });
  } catch (e) { /* noop */ }
};

export const markAllNotificationsRead = () => async () => {
  const { auth, userNotificationsRef } = firebase;
  const uid = auth.currentUser && auth.currentUser.uid;
  if (!uid) return;
  try {
    const snap = await get(userNotificationsRef(uid));
    const data = snap.val();
    if (!data) return;
    const updates = {};
    Object.keys(data).forEach((key) => {
      if (!data[key].read) {
        updates[`${key}/read`] = true;
      }
    });
    if (Object.keys(updates).length > 0) {
      await update(userNotificationsRef(uid), updates);
    }
  } catch (e) { /* noop */ }
};
